import { gql } from '__generated__';

export default gql(`
  mutation DuplicateScanner($input: EditScannerInput!) {
    duplicateScanner(input: $input) {
      id
    }
  }
`);
